import { clone } from 'lodash';

export class Store {
  id: string;
  name: string;
  address: string;
  zip_code: string;
  city: string;
  country: string;
  siret: string;
  latitude = 48.85341;
  longitude = 2.3488;
  phone_number: string;
  website: string;
  brand: any;
  networks = [];

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}

export function fromApi(payload) {
  payload['latitude']  = +payload['latitude'];
  payload['longitude'] = +payload['longitude'];

  return payload;
}

export function toApi(data) {
  data = clone(data);

  if (data.merchant && data.merchant.id) {
    data.merchant = data.merchant.id;
  }

  if (data.brand && data.brand) {
    data.brand = data.brand.id;
  }

  data.latitude  = '' + data.latitude;
  data.longitude = '' + data.longitude;

  data.business_name = data.name;

  return data;
}
